var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReferral = function SvgReferral(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.005 2.503a9.5 9.5 0 0 1 9.318 11.347 5.642 5.642 0 0 0-7.59 7.493 9.5 9.5 0 1 1-1.729-18.84m.472 5.816a.507.507 0 0 0-.943 0l-.253.612a4.37 4.37 0 0 1-2.252 2.326l-.717.32a.53.53 0 0 0 0 .963l.76.338a4.37 4.37 0 0 1 2.219 2.25l.247.567c.18.415.754.415.935 0l.246-.566a4.37 4.37 0 0 1 2.22-2.251l.76-.338a.53.53 0 0 0 0-.964l-.718-.32a4.37 4.37 0 0 1-2.251-2.325zM20.18 19.543a1.566 1.566 0 0 1 1.564 1.565v1.388h-5.478v-1.388a1.566 1.566 0 0 1 1.566-1.565z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.005 15.496a1.762 1.762 0 0 1 1.246 3.006 1.762 1.762 0 0 1-2.49-2.49 1.76 1.76 0 0 1 1.244-.516"
  })));
};
export default SvgReferral;